export const NotFoundRoute = () => {
  return (
    <div>
      <h1>404</h1>
    </div>
  );
};
